import type { DialogueStickerMessage } from 'components/Dialogue/types';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import QuoteMessage from '../QuoteMessage';
import { BaseMsgProps } from './types';
import LazyStickerMessage from '../LazyStickerMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo } from 'react';

export const StickerMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;

  const { clickQuote, dialogRef } = useChatContext();
  const { region, channel, topBarInfo } = conversation;
  const dataSource = (msg as DialogueStickerMessage).content;

  return (
    <MessageExtendComplex
      raw={raw}
      msg={msg}
      conversation={conversation}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <LazyStickerMessage
            lazyScrollContainer={dialogRef?.dom}
            region={region}
            platform={channel}
            dataSource={dataSource}
          />
        </QuoteMessage>
      }
    />
  );
});
